export default __webpack_public_path__ + "static/media/homeBG.2dbc8287.jpg";